import View from './View';

export { default as View } from './View';
export { default as getGridScreenStyles } from './styles';

export default View;
